document.addEventListener("DOMContentLoaded", function () {
  let timeLeft = 10; // 2 minutes in seconds
  let timerInterval;
  const countdownTimer = document.getElementById("countdownTimer");
  const inviteContractorButton = document.getElementById("inviteContractorButton");

  if(!countdownTimer || !countdownTimer) {
    return
  }

  function updateTimer() {
    let minutes = Math.floor(timeLeft / 60);
    let seconds = timeLeft % 60;
    countdownTimer.textContent = `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    timeLeft--;

    if (timeLeft < 0) {
      clearInterval(timerInterval);
      inviteContractorButton.style.display = "inline";
      $('#countdownContainer')?.addClass('d-none');
    }
  }

  function startTimer() {
    timeLeft = 120;
    countdownTimer.textContent = "2:00";
    $('#countdownContainer')?.removeClass('d-none');
    inviteContractorButton.style.display = "none";
    timerInterval = setInterval(updateTimer, 1000);
  }

  inviteContractorButton.addEventListener("click", function () {
    clearInterval(timerInterval);
    startTimer();

    const endpoint = inviteContractorButton.getAttribute("data-endpoint");

    fetch(endpoint)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(data => {
        console.log("GET request successful:", data);
      })
      .catch(error => {
        window.rollbar.error("There was a problem with the GET request:", error);
      });
  });

  startTimer();
});

document.addEventListener("click", function (event) {
  const button = event.target.closest(".copy-join-link-btn");
  if (!button) return;

  const url = button.getAttribute("data-url");
  const originalLabel = button.textContent;

  const copyWithFallback = () => {
    const input = document.createElement("textarea");
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
  };

  const showCopied = () => {
    button.textContent = "Link copied!";
    setTimeout(() => { button.textContent = originalLabel; }, 2000);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(url).then(showCopied).catch(() => { copyWithFallback(); showCopied(); });
  } else {
    copyWithFallback();
    showCopied();
  }
});
